import { Button, Input, Upload, message, Popconfirm } from 'antd'
import { Card } from 'layouts'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import './MonitorDetail.scss'
import { BreadNav } from '../BreadNav/BreadNav'
import { EditableProTable } from '@ant-design/pro-components'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import _ from 'lodash'
import numeral from 'numeral'
import {
    formateNull,
    getNavWidth,
    getStroage,
    exportsCSV,
    debounce,
    formatTableData,
    processCSVData,
    removeInvisibleCharacters,
    hasPerms,
    dmsToDecimal,
} from 'utils'
import { nanoid } from 'nanoid'
import Papa from 'papaparse'
import { Switch } from '@arco-design/web-react'
import '@arco-design/web-react/dist/css/arco.css'
import { BackIcon } from 'assets/icons'
import {
    pushConsumableImportData,
    pushActivityDiaryImportData,
    pushActivityDiaryStreamerImportData,
    postHSEFlagLoginData,
    postHSEFlagDataData,
    getFlagCodeDataApi,
    postHSEFlagEventDataData,
    postHSEFlagExposureDataData,
    postHSEFlagIncidentDataData,
    postMMOFlagDataData,
} from 'api'
import { IconCheck, IconClose } from '@arco-design/web-react/icon'
import { getNavDataList } from 'components/Nav/NavData'
import EditableInput from 'components/EditInput/EditInput'
import { StepModal } from 'pages/monitor/FocusAcquisition/StepModal'
import DropdownFile from 'pages/monitor/FocusAcquisition/DropdownFile'
import * as XLSX from 'xlsx'
// import { ArrowDownOutlined, DownOutlined, LoadingOutlined, UpOutlined } from '@ant-design/icons'
// import { CKEditor } from '@ckeditor/ckeditor5-react'
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export const MonitorDetail = props => {
    const {
        type,
        columnsList,
        dataSourceList,
        setDataSourceList,
        rowKeys,
        setRowKeys,
        initData,
        commentValue,
        initCommentValue,
        operationalSummary,
        next24Hours,
        handleCommentChange,
        handleOperationalSummaryChange,
        handleNext24HoursChange,
        handleAllSave,
        calendarInfo,
        btnLoading,
        needUpdate,
        setNeedUpdate,
        actionRefList,
        formRefList,
        dictData,
        authLocationList,
        tableHeaderName,
        tableHeaderLabel,
        isModifyTable,
        setIsmodifyTable,
        sourceData,
        zipperData,
        completed,
        setCompleted,
        currentSlice,
        shotsObj,
        setImportFlagData,
        shotsReceiveObj,
        setCurrentDate,
        tableHeaderReceiveName,
        tableHeaderReceiveLabel,
        shotsConsumableObj,
        hseSummary,
        shipping,
        marineTraffic,
        handleMarineTrafficChange,
        fishingSummary,
        escort,
        others,
        hours,
        operationSummary,
        handleShippingChange,
        handleOperationSummaryChange,
        muaSuspensionsSummary,
        handlemuaSuspensionsSummaryChange,
        weatherSummary,
        handleweatherSummaryChange,
        shallowWater,
        handleShallowWaterChange,
        Obstructions,
        handleObstructionsChange,
        handleOthersChange,
        handleHoursSummaryChange,
        nodeVessels,
        handlenodeVesselsChange,
        handleHseSummaryChange,
        resupplyLogistics,
        handleresupplyLogisticsChange,
        supportVessels,
        handlesupportVesselsChange,
        sourceVessels,
        handlesourceVesselsChange,
        simops,
        handlesimopsChange,
        isToolTips,
        setIsToolTips,
        typeRoute,
        saveData,
        setSaveData,
        isFileLoading,
        UploadFileFinish,
        // detailVOPage,
        uploadFile,
        // isLoading,
        // isLoadingId,
        editValue,
        setEditValue,
        headerData,
        handleEditValue,
        clearFileData,
        importBeforeDayData,
        isUpdate,
        beforeOneDayData,
        tableHeaderDrillName,
        tableHeaderDrillLabel,
        setIsModalVisibleCheck,
        isModalVisibleCheck,
        UploadSPSFileFinish,
        averageType,
        setAverageType,
        fileList,
        handleDelete,
        setIsFileLoading,
        setFileList,
        isFirstRender,
        setGeometryFile,
        isAllowUpdate,
        shotsConsumptionObj,
    } = props

    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const language = getStroage('language')
    const locationName = useSelector(state => state.LocationSlice.locationName)
    const locationId = useSelector(state => state.LocationSlice.locationId)
    const locationType = useSelector(state => state.LocationSlice.locationType)
    const callSign = useSelector(state => state.LocationSlice.callSign)
    const selectedKeys = useSelector(state => state.NavSlice.selectedKeys)
    const userInfo = useSelector(state => state.HeaderSlice.userInfo)
    const projectBaseData = useSelector(state => state.HeaderSlice.projectBaseData)
    const localTimeDifference = projectBaseData?.data?.localTimeDifference
    const receiverTypeList = projectBaseData?.data?.receiverType
    const unlockStartDate = userInfo?.project?.unlockStartDate
    const outlineBorder = useSelector(state => state.HeaderSlice.outlineBorder)
    const navList = getNavDataList()
    // const permissions = userInfo?.permissions
    // const LeaderAuth = posts?.find(p => p === 'secondLeader')
    // const LeaderAuth2 = posts?.find(p => p === 'thirdLeader')
    // const LeaderAuth3 = posts?.find(p => p === 'firstLeader')
    const [loading, setLoading] = useState(false) // 导出表格数据
    // const isFirstRender = useRef(true)
    // const isSecondRender = useRef(true)
    const isLock = userInfo?.project?.isLock
    const readOnly = isLock ? true : dayjs(calendarInfo).format('YYYY-MM-DD') < unlockStartDate
    // const isUpload = type === 'Vibrator'
    // const { Panel } = Collapse
    /* ====================================================================================================================================================== */
    const [excelData, setExcelData] = useState() // 导出表格数据
    const [fileName] = useState(() => locationName + ' Source (OBN) ' + dayjs(calendarInfo).format('YYYY-MM-DD')) // 下载文件名
    const [fileNameActivityDiary] = useState(
        () => locationName + ' Activity Diary ' + dayjs(calendarInfo).format('YYYY-MM-DD')
    ) // 下载文件名
    const [fileNameProjectActivityDiary] = useState(
        () => locationName + ' Project Summary ' + dayjs(calendarInfo).format('YYYY-MM-DD')
    ) // 下载文件名
    const [reciveFileName] = useState(
        () => locationName + ' Deployment / Retrieval ' + dayjs(calendarInfo).format('YYYY-MM-DD')
    )
    const [VIBFileName] = useState(() => locationName + ' Source(Land) ' + dayjs(calendarInfo).format('YYYY-MM-DD'))
    useEffect(() => setExcelData(dataSourceList?.[0]), [dataSourceList?.[0]]) // 更新接口回显数据

    /* 快捷操作 */
    useEffect(() => {
        if (!userInfo) return
        let oldTime = Date.now()
        let currentDate = calendarInfo
        let start, end
        if (type === 'Acquisition') {
            start = userInfo?.project?.acquisitionStartDate
            end = dayjs(userInfo?.project?.acquisitionEndDate).add(1, 'day').format('YYYY-MM-DD')
        }
        if (type === 'Receiver') {
            start = userInfo?.project?.receiverStartDate
            end = dayjs(userInfo?.project?.receiverEndDate).add(1, 'day').format('YYYY-MM-DD')
        } else {
            start = userInfo?.project?.firstReportDate
            end = dayjs(userInfo?.project?.lastReportDate).add(1, 'day').format('YYYY-MM-DD')
        }
        const handleFun = e => {
            if (e.ctrlKey && e.code === 'ArrowLeft') {
                const newTime = Date.now()
                if (newTime - oldTime < 800) {
                    if (currentDate <= start) {
                        message.warning(t('common.tips22'))
                        return
                    }
                    currentDate = dayjs(currentDate).subtract(1, 'day').format('YYYY-MM-DD')
                    return
                } else {
                    if (currentDate <= start) {
                        message.warning(t('common.tips22'))
                        return
                    }
                    currentDate = dayjs(currentDate).subtract(1, 'day').format('YYYY-MM-DD')
                    oldTime = newTime
                    dispatch(currentSlice.actions.addCalendarInfo(currentDate))
                    window.location.reload()
                }
            } else if (e.ctrlKey && e.code === 'ArrowRight') {
                const newTime = Date.now()
                if (newTime - oldTime < 800) {
                    if (currentDate >= end) {
                        message.warning(t('common.tips23'))
                        return
                    }
                    currentDate = dayjs(currentDate).add(1, 'day').format('YYYY-MM-DD')
                    return
                } else {
                    if (currentDate >= end) {
                        message.warning(t('common.tips23'))
                        return
                    }
                    currentDate = dayjs(currentDate).add(1, 'day').format('YYYY-MM-DD')
                    oldTime = newTime
                    dispatch(currentSlice.actions.addCalendarInfo(currentDate))
                    window.location.reload()
                }
            }
        }
        window.addEventListener('keydown', handleFun, false)
        return () => {
            window.removeEventListener('keydown', handleFun)
        }
    }, [calendarInfo, userInfo])

    // 格式化数据
    const formatExcelData = excelData => {
        if (!excelData || excelData.length === 0) return []
        return excelData?.map(item => {
            const newItem = { ...item }
            delete newItem.id
            delete newItem.countNum
            const newType = dictData[0].data.data.find(p => p.dictValue === item.type)
            newItem.type = language === 'zh' ? newType?.dictLabel : newType?.dictLabelEn
            const newActivity = dictData[0].data.data.find(p => p.dictValue === item.activity)
            newItem.activity = language === 'zh' ? newActivity?.dictLabel : newActivity?.dictLabelEn
            const newAreaType = dictData[4].data.data.find(p => p.dictValue === item.areaType)
            newItem.areaType = language === 'zh' ? newAreaType?.dictLabel : newAreaType?.dictLabelEn
            const newStatus = dictData[1].data.data.find(p => p.dictValue === item.status)
            newItem.status = language === 'zh' ? newStatus?.dictLabel : newStatus?.dictLabelEn
            const newSwath = dictData[2].data.data.find(p => p.id === item.swath)
            newItem.swath = newSwath?.fileName
            const newSourceParameters = sourceData?.find(p => p.id === item.sourceParameter)
            newItem.sourceParameter = newSourceParameters?.name
            const newZipperId = zipperData?.find(p => p.id === item.zipperId)
            newItem.zipperId = newZipperId?.name
            return newItem
        })
    }

    // 格式化数据 节点收放
    const formatExcelReivceData = excelData => {
        if (!excelData || excelData.length === 0) return []
        return excelData?.map(item => {
            const newItem = { ...item }
            delete newItem.id
            delete newItem.countNum
            const newActivity = dictData[0].data.data.find(p => p.dictValue === item.activity)
            newItem.activity = language === 'zh' ? newActivity?.dictLabel : newActivity?.dictLabelEn
            const newType = dictData[5].data.data.find(p => p.dictValue === item.type)
            newItem.type = language === 'zh' ? newType?.dictLabel : newType?.dictLabelEn
            const newStatus = dictData[1].data.data.find(p => p.dictValue === item.status)
            newItem.status = language === 'zh' ? newStatus?.dictLabel : newStatus?.dictLabelEn
            const newMethod = dictData[2].data.data.find(p => p.dictValue === item.method)
            newItem.method = language === 'zh' ? newMethod?.dictLabel : newMethod?.dictLabelEn
            const newSwath = dictData[3].data.data.find(p => p.id === item.swath)
            newItem.swath = newSwath?.fileName
            const newSourceParameters = sourceData?.find(p => p.id === item.sourceParameter)
            newItem.sourceParameter = newSourceParameters?.name
            const newZipperId = zipperData?.find(p => p.id === item.zipperId)
            newItem.zipperId = newZipperId?.name
            return newItem
        })
    }

    // 格式化数据 炮点激发 VIB
    const formatExcelFocusAcquisitionData = excelData => {
        if (!excelData || excelData.length === 0) return []
        return excelData?.map(item => {
            const newItem = { ...item }
            delete newItem.id
            delete newItem.countNum
            const newGroupName = dictData[0].find(p => p.dictValue === item.groupName)
            newItem.groupName = language === 'zh' ? newGroupName?.dictLabel : newGroupName?.dictLabelEn
            const newAcquisitionType = dictData[1].find(p => p.dictValue === item.acquisitionType)
            newItem.acquisitionType =
                language === 'zh' ? newAcquisitionType?.dictLabel : newAcquisitionType?.dictLabelEn
            const newActivityType = dictData[2].find(p => p.dictValue === item.activityType)
            newItem.activityType = language === 'zh' ? newActivityType?.dictLabel : newActivityType?.dictLabelEn
            const newZipperId = zipperData?.find(p => p.id === item.zipperId)
            newItem.zipperId = newZipperId?.name
            return newItem
        })
    }

    // ActivityDiary格式化数据
    const formatExcelDataActivityDiary = excelData => {
        if (!excelData || excelData.length === 0) return []
        return excelData?.map(item => {
            const newItem = { ...item }
            const newType = dictData[0].data.data.filter(p => item.activityType.indexOf(p.dictValue) !== -1)
            newItem.activityType = ''
            newType.forEach(item => {
                newItem.activityType += language === 'zh' ? item?.dictLabel + ',' : item?.dictLabelEn + ','
            })
            newItem.activityType = newItem.activityType.slice(0, -1)
            newItem.duration = newItem.duration ? numeral(newItem.duration / 60).format('0.00') : ''
            return newItem
        })
    }

    // 导入导出 CSV 文件
    // const handleExportExcel = () => exportFile(formatExcelData(excelData), fileName, tableHeaderName, tableHeaderLabel)
    // const handleImportExcel = file =>
    //     importExcel(file)
    //         .then(res => {
    //             const jsonData = res?.[0]
    //             if (!jsonData) return
    //             let row = 0
    //             const headerMap = {}
    //             const resultTableData = []
    //             for (let key of Object.keys(jsonData)) {
    //                 if (key !== '!ref') {
    //                     const currentRow = Number(/[0-9]+/.exec(key)?.[0])
    //                     const currentCol = /[a-zA-Z]+/.exec(key)?.[0]
    //                     if (/[a-zA-Z]+1(?!\d)/.test(key))
    //                         headerMap[getTableHeaderTrueName(jsonData[key].v)] = currentCol // 获取 table 表头信息
    //                     if (currentRow > row) row = currentRow // 获取 table 行数
    //                 }
    //             }
    //             for (let i = 0; i < row - 1; i++) {
    //                 const newObj = {}
    //                 for (let key of Object.keys(headerMap)) {
    //                     const colName = String(headerMap[key])
    //                     const rowName = String(i + 2)
    //                     newObj[key] = jsonData[colName + rowName]?.v
    //                     newObj.id = nanoid()
    //                 }

    //                 newObj.type = dictData[0].data.data.find(
    //                     p => p.dictLabel === newObj.type || p.dictLabelEn === newObj.type
    //                 )?.dictValue
    //                 newObj.status = dictData[1].data.data.find(
    //                     p => p.dictLabel === newObj.status || p.dictLabelEn === newObj.status
    //                 )?.dictValue
    //                 newObj.swath = dictData[2].data.data.find(p => p.fileName === newObj.swath)?.id
    //                 newObj.sourceParameter = sourceData?.find(p => p.name === newObj.sourceParameter)?.id
    //                 newObj.zipperId = zipperData?.find(p => p.name === String(newObj.zipperId))?.id
    //                 resultTableData.push(newObj)
    //             }

    //             setDataSourceList[0](resultTableData) // 更新结果
    //             setIsmodifyTable(true)
    //         })
    //         .catch(err => {
    //             message.error('导入 excel 格式不符合系统规范')
    //         })

    // 导入导出 cvs 文件
    const handleExportCSV = () => {
        const dataString = Papa.unparse(formatExcelData(excelData), {
            columns: tableHeaderName, // 指定列的顺序，如果需要其他配置表 https://www.papaparse.com/docs#unparse-config-default
        })
        const oldHeader = tableHeaderName.join()
        const newHeader = Object.values(tableHeaderLabel).join()
        const data = dataString ? dataString?.replace(oldHeader, newHeader) : newHeader
        const timeData = processCSVData(data)
        exportsCSV({ _body: timeData, name: fileName })
    }
    const handleImportCSV = file =>
        Papa.parse(file, {
            complete: (results, file) => {
                let data = results?.data
                if (!data) return
                const lastIteam = data.slice(-1)[0]
                if (lastIteam.length === 1 && lastIteam[0] === '') data.pop()
                const resultTableData = []
                for (let i = 0; i < data.length - 1; i++) {
                    const newObj = {}
                    for (let p = 0; p < tableHeaderName.length; p++) {
                        newObj[tableHeaderName[p]] = data[i + 1][p]
                        newObj.id = nanoid()
                    }

                    newObj.type = dictData[0].data.data.find(
                        p => p.dictLabel === newObj.type || p.dictLabelEn === newObj.type
                    )?.dictValue
                    newObj.areaType = dictData[4].data.data.find(
                        p => p.dictLabel === newObj.areaType || p.dictLabelEn === newObj.areaType
                    )?.dictValue
                    newObj.status = dictData[1].data.data.find(
                        p => p.dictLabel === newObj.status || p.dictLabelEn === newObj.status
                    )?.dictValue
                    newObj.swath = dictData[2].data.data.find(p => p.fileName === newObj.swath)?.id
                    newObj.sourceParameter = sourceData?.find(p => p.name === newObj.sourceParameter)?.id
                    newObj.zipperId = zipperData?.find(p => p.name === String(newObj.zipperId))?.id
                    newObj.fspTime = removeInvisibleCharacters(newObj.fspTime)
                    newObj.solTime = removeInvisibleCharacters(newObj.solTime)
                    newObj.eolTime = removeInvisibleCharacters(newObj.eolTime)
                    newObj.lspTime = removeInvisibleCharacters(newObj.lspTime)
                    resultTableData.push(newObj)
                }
                setDataSourceList[0](resultTableData) // 更新结果
                setIsmodifyTable(true)
            },
            error: (err, file) => message.error('导入 csv 格式不符合系统规范'),
        })

    // 导入导出 HSE Diart 文件
    const handleExportHSEDiaryExcel = () => {
        const sheetData = {
            sheet1: {
                name: t(`${type}.${'tableTitle' + 1}`),
                data: dataSourceList[0] || [],
            },
            sheet2: {
                name: t(`${type}.${'tableTitle' + 2}`),
                data: dataSourceList[1] || [],
            },
            sheet3: {
                name: t(`${type}.${'tableTitle' + 3}`),
                data: dataSourceList[2] || [],
            },
            sheet4: {
                name: t(`${type}.${'tableTitle' + 4}`),
                data: dataSourceList[3] || [],
            },
        }
        const getMultiDictLabel = (values, dictList, lang) => {
            // 统一转为数组（兼容单个值/数组值）
            const valueArr = Array.isArray(values) ? values : [values]
            const labels = []

            // 遍历每个值，匹配字典标签
            valueArr.forEach(val => {
                if (val) {
                    // 过滤空值
                    const dictItem = dictList?.find(p => p.dictValue === val)
                    // 根据语言取标签，匹配失败则保留原始值
                    const label = lang === 'zh' ? dictItem?.dictLabel || val : dictItem?.dictLabelEn || val
                    labels.push(label)
                }
            })

            // 拼接多个标签为字符串（逗号分隔）
            return labels.join(',')
        }
        // 1. 创建一个空的工作簿（Excel文件容器）
        const workbook = XLSX.utils.book_new()

        const addSheet = sheetInfo => {
            const { name, data } = sheetInfo
            const newData = data.map(row => {
                const newRow = {}
                Object.keys(row).forEach(field => {
                    if (tableHeaderLabel[field]) {
                        let fieldValue = row[field] ?? ''

                        if (field === 'cardType' && fieldValue) {
                            fieldValue = getMultiDictLabel(fieldValue, dictData[0]?.data?.data, language)
                        }
                        if (field === 'eventType' && fieldValue) {
                            fieldValue = getMultiDictLabel(fieldValue, dictData[1]?.data?.data, language)
                        }
                        if (field === 'company' && fieldValue) {
                            fieldValue = getMultiDictLabel(fieldValue, dictData[2]?.data?.data, language)
                        }
                        if (field === 'personnelType' && fieldValue) {
                            fieldValue = getMultiDictLabel(fieldValue, dictData[3]?.data?.data, language)
                        }
                        if (field === 'exposureHour' && fieldValue) {
                            fieldValue = getMultiDictLabel(fieldValue, dictData[4]?.data?.data, language)
                        }
                        if (field === 'incidentType' && fieldValue) {
                            fieldValue = getMultiDictLabel(fieldValue, dictData[5]?.data?.data, language)
                        }

                        newRow[tableHeaderLabel[field]] = fieldValue
                    }
                })
                return newRow
            })
            const sheet = XLSX.utils.json_to_sheet(newData)
            XLSX.utils.book_append_sheet(workbook, sheet, name)
        }

        // 生成4个Sheet
        addSheet(sheetData.sheet1)
        addSheet(sheetData.sheet2)
        addSheet(sheetData.sheet3)
        addSheet(sheetData.sheet4)

        // 3. 导出Excel文件（触发浏览器下载）
        XLSX.writeFile(workbook, `${fileName}.xlsx`)
    }

    // 导入导出 Receive cvs 文件
    const handleExportReceiveCSV = () => {
        const dataString = Papa.unparse(formatExcelReivceData(excelData), {
            columns: tableHeaderReceiveName, // 指定列的顺序，如果需要其他配置表 https://www.papaparse.com/docs#unparse-config-default
        })
        const oldHeader = tableHeaderReceiveName.join()
        const newHeader = Object.values(tableHeaderReceiveLabel).join()
        const data = dataString ? dataString?.replace(oldHeader, newHeader) : newHeader
        const timeData = processCSVData(data)
        exportsCSV({ _body: timeData, name: reciveFileName })
    }
    const handleImportReceiveCSV = file =>
        Papa.parse(file, {
            complete: (results, file) => {
                const data = results?.data
                if (!data) return

                const resultTableData = []
                for (let i = 0; i < data.length - 1; i++) {
                    const newObj = {}
                    for (let p = 0; p < tableHeaderReceiveName.length; p++) {
                        newObj[tableHeaderReceiveName[p]] = data[i + 1][p]
                        newObj.id = nanoid()
                    }
                    newObj.type = dictData[5].data.data.find(
                        p => p.dictLabel === newObj.type || p.dictLabelEn === newObj.type
                    )?.dictValue
                    newObj.activity = dictData[0].data.data.find(
                        p => p.dictLabel === newObj.activity || p.dictLabelEn === newObj.activity
                    )?.dictValue
                    newObj.status = dictData[1].data.data.find(
                        p => p.dictLabel === newObj.status || p.dictLabelEn === newObj.status
                    )?.dictValue
                    newObj.method = dictData[2].data.data.find(
                        p => p.dictLabel === newObj.method || p.dictLabelEn === newObj.method
                    )?.dictValue
                    newObj.swath = dictData[3].data.data.find(p => p.fileName === newObj.swath)?.id
                    newObj.sourceParameter = sourceData?.find(p => p.name === newObj.sourceParameter)?.id
                    newObj.zipperId = zipperData?.find(p => p.name === String(newObj.zipperId))?.id
                    newObj.solTime = removeInvisibleCharacters(newObj.solTime)
                    newObj.eolTime = removeInvisibleCharacters(newObj.eolTime)
                    resultTableData.push(newObj)
                }
                setDataSourceList[0](resultTableData) // 更新结果
                setIsmodifyTable(true)
            },
            error: (err, file) => message.error('导入 csv 格式不符合系统规范'),
        })

    // 导入导出 VIB cvs 文件
    const handleExportVIBCSV = () => {
        const dataString = Papa.unparse(formatExcelFocusAcquisitionData(excelData), {
            columns: tableHeaderDrillName, // 指定列的顺序，如果需要其他配置表 https://www.papaparse.com/docs#unparse-config-default
        })
        const oldHeader = tableHeaderDrillName.join()
        const newHeader = Object.values(tableHeaderDrillLabel).join()
        const data = dataString ? dataString?.replace(oldHeader, newHeader) : newHeader
        const timeData = processCSVData(data)
        exportsCSV({ _body: timeData, name: VIBFileName })
    }
    // const handleImportVIBCSV = file =>
    //     Papa.parse(file, {
    //         complete: (results, file) => {
    //             const data = results?.data
    //             if (!data) return

    //             const resultTableData = []
    //             for (let i = 0; i < data.length - 1; i++) {
    //                 const newObj = {}
    //                 for (let p = 0; p < tableHeaderDrillName.length; p++) {
    //                     newObj[tableHeaderDrillName[p]] = data[i + 1][p]
    //                     newObj.id = nanoid()
    //                 }
    //                 newObj.groupName = dictData[0].find(
    //                     p => p.dictLabel === newObj.groupName || p.dictLabelEn === newObj.groupName
    //                 )?.dictValue
    //                 newObj.acquisitionType = dictData[1].find(
    //                     p => p.dictLabel === newObj.acquisitionType || p.dictLabelEn === newObj.acquisitionType
    //                 )?.dictValue
    //                 newObj.activityType = dictData[2].find(
    //                     p => p.dictLabel === newObj.activityType || p.dictLabelEn === newObj.activityType
    //                 )?.dictValue
    //                 newObj.zipperId = zipperData?.find(p => p.name === String(newObj.zipperId))?.id
    //                 resultTableData.push(newObj)
    //             }
    //             setDataSourceList[0](resultTableData) // 更新结果
    //             setIsmodifyTable(true)
    //         },
    //         error: (err, file) => message.error('导入 csv 格式不符合系统规范'),
    //     })

    // 导入导出 ActivityDiary cvs 文件
    const handleExportActivityDiaryCSV = () => {
        const dataString = Papa.unparse(formatExcelDataActivityDiary(excelData), {
            columns: tableHeaderName, // 指定列的顺序，如果需要其他配置表 https://www.papaparse.com/docs#unparse-config-default
        })
        const oldHeader = tableHeaderName.join()
        const newHeader = Object.values(tableHeaderLabel).join()
        const data = dataString ? dataString?.replace(oldHeader, newHeader) : newHeader
        const timeData = processCSVData(data)
        exportsCSV({ _body: timeData, name: fileNameActivityDiary })
    }
    const handleImportActivityDiaryCSV = file =>
        Papa.parse(file, {
            complete: (results, file) => {
                const data = results?.data
                if (!data) return

                const resultTableData = []
                for (let i = 0; i < data.length - 1; i++) {
                    const newObj = {}
                    for (let p = 0; p < tableHeaderName.length; p++) {
                        newObj[tableHeaderName[p]] = data[i + 1][p]
                        newObj.id = nanoid()
                    }
                    newObj.activityType = newObj.activityType.split(',')
                    newObj.activityType = dictData[0]?.data.data.filter(
                        item =>
                            newObj.activityType.indexOf(item.dictLabelEn) !== -1 ||
                            newObj.activityType.indexOf(item.dictLabel) !== -1
                    )
                    newObj.activityType = newObj.activityType.slice(0, 2).map(item => item.dictValue)
                    newObj.duration = newObj.duration ? numeral(newObj.duration * 60).format('0.00') : ''
                    newObj.startTime = removeInvisibleCharacters(newObj.startTime)
                    newObj.endTime = removeInvisibleCharacters(newObj.endTime)
                    resultTableData.push(newObj)
                }
                setDataSourceList[0](resultTableData) // 更新结果
                setIsmodifyTable(true)
            },
            error: (err, file) => message.error('导入 csv 格式不符合系统规范'),
        })

    // 导入导出 Project Summary 文件
    const handleExportProjectActivityCSV = () => {
        const dataString = Papa.unparse(formatExcelDataActivityDiary(excelData), {
            columns: tableHeaderName, // 指定列的顺序，如果需要其他配置表 https://www.papaparse.com/docs#unparse-config-default
        })
        const oldHeader = tableHeaderName.join()
        const newHeader = Object.values(tableHeaderLabel).join()
        const data = dataString ? dataString?.replace(oldHeader, newHeader) : newHeader
        const timeData = processCSVData(data)
        exportsCSV({ _body: timeData, name: fileNameProjectActivityDiary })
    }

    /* ====================================================================================================================================================== */

    /* 是否拥有修改权限 */
    let permissionCode = ''

    let productionList = navList?.filter(item => item.key === 'production')[0]

    productionList?.children?.forEach(item => {
        if (item.menuCode === typeRoute) {
            permissionCode = item.permission
        }
    })

    /* 获取总耗时 */
    const getAllDuration = data => {
        if (!data) return ''
        let result = 0
        data.forEach(item => {
            if (item.duration) {
                result += Number(item.duration)
            }
        })
        return numeral(result / 60).format('0.00')
    }

    useEffect(() => {
        if (isAllowUpdate) {
            setNeedUpdate(true)
            return
        }
        if (type === 'MMO') {
            if (commentValue[0] !== initCommentValue[0]) return
        } else {
            if (commentValue !== initCommentValue) return
        }
        const one = formateNull(initData)
        const two = formateNull(dataSourceList)
        const result = !_.isEqual(one, two) // 深比较
        if (isModifyTable) setNeedUpdate(result)
    })

    // 隐藏 表格操作 option
    const editColumnsList = columnsList?.map(item => {
        return item?.map(col => {
            if (!hasPerms(permissionCode, 'monitor', locationId, readOnly)) {
                return col
            } else {
                if (col.valueType === 'option') {
                    return {
                        ...col,
                        render: () => null,
                    }
                } else {
                    return col
                }
            }
        })
    })

    return (
        <div className='MonitorDetail'>
            {/* 顶部模块 */}
            <Card
                className='topDetail'
                style={{ width: `calc(100% - ${outlineBorder ? '60px' : getNavWidth(language) + 6 + 'px'} - 56px)` }}
            >
                {/* 左边 */}
                <div className='title'>
                    <BackIcon
                        className='return-btn'
                        onClick={() => navigate(selectedKeys[0], { state: { authLocationList } })}
                    />
                    <div className='date'>
                        <div className='year'>{dayjs(calendarInfo).format('YYYY')}</div>
                        <div className='day'>{dayjs(calendarInfo).format('MM-DD')}</div>
                    </div>
                    <BreadNav />
                    {locationType !== 'outdoor' && <div className='locationName'>{'@ ' + locationName}</div>}
                </div>

                {/* 右边 */}
                <div className='rightBtn'>
                    {type === 'Waste' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                        <Popconfirm
                            title={t('Weather.tips2')}
                            onConfirm={() => {
                                const dayBefore = dayjs(calendarInfo).subtract(1, 'day').format('YYYY-MM-DD')
                                setCurrentDate(dayBefore)
                                setIsmodifyTable(true)
                                setIsToolTips(false)
                            }}
                            onCancel={() => {
                                setIsToolTips(false)
                            }}
                            okText={t('common.OK')}
                            cancelText={t('common.cancel')}
                            visible={isToolTips}
                        >
                            <div
                                className='copyPervious'
                                onClick={() => {
                                    if (
                                        dataSourceList[0].length !== 0 ||
                                        dataSourceList[1].length !== 0 ||
                                        commentValue !== ''
                                    ) {
                                        setIsToolTips(true)
                                        return
                                    }
                                    const dayBefore = dayjs(calendarInfo).subtract(1, 'day').format('YYYY-MM-DD')
                                    setCurrentDate(dayBefore)
                                    setIsmodifyTable(true)
                                }}
                            >
                                {t('Weather.copyPervious')}
                            </div>
                        </Popconfirm>
                    )}
                    {type === 'FleetSummary' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                        <Popconfirm
                            title={t('Weather.tips2')}
                            onConfirm={() => {
                                const dayBefore = dayjs(calendarInfo).subtract(1, 'day').format('YYYY-MM-DD')
                                setCurrentDate(dayBefore)
                                setIsmodifyTable(true)
                                setIsToolTips(false)
                            }}
                            onCancel={() => {
                                setIsToolTips(false)
                            }}
                            okText={t('common.OK')}
                            cancelText={t('common.cancel')}
                            visible={isToolTips}
                        >
                            <div
                                className='copyPervious'
                                onClick={() => {
                                    if (
                                        fishingSummary !== '' ||
                                        escort !== '' ||
                                        hseSummary !== '' ||
                                        shipping !== '' ||
                                        others !== '' ||
                                        operationSummary !== '' ||
                                        hours !== ''
                                    ) {
                                        setIsToolTips(true)
                                        return
                                    }
                                    const dayBefore = dayjs(calendarInfo).subtract(1, 'day').format('YYYY-MM-DD')
                                    setCurrentDate(dayBefore)
                                    setIsmodifyTable(true)
                                }}
                            >
                                {t('Weather.copyPervious')}
                            </div>
                        </Popconfirm>
                    )}
                    {type === 'Vibrator' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                        <div>
                            {/* <Upload
                                beforeUpload={file => {
                                    handleImportVIBCSV(file)
                                    return false
                                }}
                                maxCount={1}
                                itemRender={() => <></>}
                                accept='.csv'
                            >
                                <span className='import'>{t('Acquisition.import')}</span>
                            </Upload> */}
                            <DropdownFile
                                fileList={fileList}
                                handleDelete={handleDelete}
                                isFirstRender={isFirstRender}
                            />
                            <span
                                className='import'
                                onClick={() => {
                                    setIsModalVisibleCheck(true)
                                    setAverageType('production')
                                }}
                            >
                                {t('Acquisition.import')}
                            </span>
                            <StepModal
                                setIsModalVisibleCheck={setIsModalVisibleCheck}
                                isModalVisibleCheck={isModalVisibleCheck}
                                isFileLoading={isFileLoading}
                                UploadFileFinish={UploadFileFinish}
                                UploadSPSFileFinish={UploadSPSFileFinish}
                                averageType={averageType}
                                setAverageType={setAverageType}
                                setIsFileLoading={setIsFileLoading}
                                projectId={userInfo?.user?.projectId}
                                calendarInfo={calendarInfo}
                                setFileList={setFileList}
                                setGeometryFile={setGeometryFile}
                            />
                        </div>
                    )}
                    {!hasPerms(permissionCode, 'monitor', locationId, readOnly) ? (
                        <Switch
                            checkedText={' ' + t('common.logStatusFinal')}
                            uncheckedText={t('common.logStatusPending') + ' '}
                            checkedIcon={<IconCheck />}
                            uncheckedIcon={<IconClose />}
                            checked={completed}
                            disabled={isUpdate}
                            size='default'
                            type='circle'
                            onChange={value => {
                                setCompleted(value)
                                setNeedUpdate(true)
                                setIsmodifyTable(false)
                            }}
                        />
                    ) : (
                        <></>
                    )}
                    {type === 'HseDiary' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) ? (
                        <>
                            <div className='importAndExport'>
                                <span className='exportActivityDiary' onClick={handleExportHSEDiaryExcel}>
                                    {t('Acquisition.export')}
                                </span>
                            </div>
                            <Button
                                type='button'
                                className='ant-btn ant-btn-default btn importFromFlag'
                                loading={loading}
                                onClick={async () => {
                                    // flag 1.0
                                    // setLoading(true)
                                    // pushHSEImportData({
                                    //     locationIds: [locationId],
                                    //     projectId: userInfo?.user?.projectId,
                                    //     startDate: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                    //     endDate: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                    // })
                                    //     .then(res => {
                                    //         setLoading(false)
                                    //         setImportFlagData(res?.data?.data)
                                    //         message.success(t('common.tips20'))
                                    //     })
                                    //     .catch(err => {
                                    //         setLoading(false)
                                    //         message.success(t('common.tips21'))
                                    //     })
                                    // flag 2.0
                                    setLoading(true)
                                    const getTfcTimezone = localTimeDifference => {
                                        const hours = localTimeDifference / 60

                                        if (hours === 0) {
                                            return 'UTC 0'
                                        }

                                        return hours > 0 ? `UTC +${hours}` : `UTC ${hours}`
                                    }
                                    const res = await postHSEFlagLoginData({
                                        email: 'megaShare@bgpo.com',
                                        password: 'BGPoMegaShare789*',
                                        companyId: '2',
                                    }).catch(err => {
                                        setLoading(false)
                                        message.success(t('common.tips21'))
                                    })
                                    const token = res?.data?.data?.access_token
                                    // cardType
                                    const flagData = await postHSEFlagDataData(
                                        {
                                            date: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                            locationCallSign: callSign,
                                            timezone: getTfcTimezone(localTimeDifference),
                                        },
                                        token
                                    ).catch(err => {
                                        setLoading(false)
                                        message.success(t('common.tips21'))
                                    })
                                    // eventType
                                    const flagEventData = await postHSEFlagEventDataData(
                                        {
                                            date: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                            locationCallSign: callSign,
                                            timezone: getTfcTimezone(localTimeDifference),
                                        },
                                        token
                                    ).catch(err => {
                                        setLoading(false)
                                        message.success(t('common.tips21'))
                                    })
                                    // Exposure
                                    const flagExposureData = await postHSEFlagExposureDataData(
                                        {
                                            date: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                            locationCallSign: callSign,
                                            timezone: getTfcTimezone(localTimeDifference),
                                        },
                                        token
                                    ).catch(err => {
                                        setLoading(false)
                                        message.success(t('common.tips21'))
                                    })
                                    // Incident
                                    const flagIncidentData = await postHSEFlagIncidentDataData(
                                        {
                                            date: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                            locationCallSign: callSign,
                                            timezone: getTfcTimezone(localTimeDifference),
                                        },
                                        token
                                    ).catch(err => {
                                        setLoading(false)
                                        message.success(t('common.tips21'))
                                    })
                                    const cardData = Object.values(flagData?.data?.data).flat() || []
                                    const eventData = Object.values(flagEventData?.data?.data).flat() || []
                                    const companyCardList = [...new Set(eventData.map(item => item.company))] || []
                                    const exposureData = flagExposureData?.data?.data?.exposureHours || []
                                    const incidentData = flagIncidentData?.data?.data?.incidentReport || []
                                    const SOPCardList = [...new Set(cardData?.map(item => item.cardType))] || []
                                    const EventCardList = [...new Set(eventData?.map(item => item.eventType))] || []
                                    const exposureCardList =
                                        [...new Set(exposureData?.map(item => item.personnelType))] || []
                                    const exposureHoursCardList =
                                        [...new Set(exposureData?.map(item => item.exposureHours))] || []
                                    const incidentCardList =
                                        [...new Set(incidentData?.map(item => item.incidentType))] || []
                                    const personnelTypeCardList =
                                        [...new Set(incidentData?.map(item => item.personnelType))] || []
                                    const shareCodeList = await getFlagCodeDataApi(
                                        [
                                            ...SOPCardList,
                                            ...EventCardList,
                                            ...exposureCardList,
                                            ...incidentCardList,
                                            ...personnelTypeCardList,
                                            ...companyCardList,
                                            ...exposureHoursCardList,
                                        ],
                                        userInfo?.user?.projectId
                                    ).catch(err => {
                                        setLoading(false)
                                        message.success(t('common.tips21'))
                                    })
                                    await cardData?.forEach((item, index) => {
                                        item.id = index
                                        item.isTofs = item.isTOFS
                                        // if (item.isTOFS === 1) {
                                        //     item.cardType = '17-731'
                                        //     return
                                        // }
                                        const target = shareCodeList?.data?.data?.find(ele => {
                                            return ele.flagCode === item.cardType
                                        })
                                        if (target) {
                                            item.cardType = target.dictValue
                                        }
                                    })
                                    await eventData?.forEach((item, index) => {
                                        item.id = index
                                        const target = shareCodeList?.data?.data?.find(ele => {
                                            return ele.flagCode === item.eventType
                                        })
                                        const eventCompanyCardTarget = shareCodeList?.data?.data?.find(ele => {
                                            return ele.flagCode === item.company
                                        })
                                        if (target) {
                                            item.eventType = target.dictValue
                                        }
                                        if (eventCompanyCardTarget) {
                                            item.company = eventCompanyCardTarget.dictValue
                                        }
                                    })
                                    await exposureData?.forEach((item, index) => {
                                        item.id = index
                                        const target = shareCodeList?.data?.data?.find(ele => {
                                            return ele.flagCode === item.personnelType
                                        })
                                        const targetExposureHour = dictData?.[4]?.data?.data?.find(ele => {
                                            return Number(ele.dictLabel) === Number(item.exposureHours)
                                        })
                                        if (target) {
                                            item.personnelType = target.dictValue
                                        }
                                        if (targetExposureHour) {
                                            item.exposureHour = targetExposureHour.dictValue
                                        }
                                    })
                                    await incidentData?.forEach((item, index) => {
                                        item.id = index
                                        const target = shareCodeList?.data?.data?.find(ele => {
                                            return ele.flagCode === item.incidentType
                                        })
                                        const perTarget = shareCodeList?.data?.data?.find(ele => {
                                            return ele.flagCode === item.personnelType
                                        })
                                        if (target) {
                                            item.incidentType = target.dictValue
                                        }
                                        if (perTarget) {
                                            item.personnelType = perTarget.dictValue
                                        }
                                        if (item.time) {
                                            item.time = item.time.match(/ (\d{2}:\d{2}):/)[1]
                                        }
                                    })
                                    setLoading(false)
                                    setImportFlagData({
                                        HseIncidentsObservation: cardData,
                                        HseDiaryEvent: eventData,
                                        HseDiaryExposureHour: exposureData,
                                        HseIncident: { data: { data: incidentData } },
                                    })
                                    message.success(t('common.tips20'))
                                }}
                            >
                                {t('HseDiary.importFromFlag')}
                            </Button>
                        </>
                    ) : (
                        <></>
                    )}
                    {type === 'MMO' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) ? (
                        <>
                            <Button
                                type='button'
                                className='ant-btn ant-btn-default btn importFromFlag'
                                loading={loading}
                                onClick={async () => {
                                    setLoading(true)
                                    const getTfcTimezone = localTimeDifference => {
                                        const hours = localTimeDifference / 60

                                        if (hours === 0) {
                                            return 'UTC 0'
                                        }

                                        return hours > 0 ? `UTC +${hours}` : `UTC ${hours}`
                                    }
                                    const res = await postHSEFlagLoginData({
                                        email: 'megaShare@bgpo.com',
                                        password: 'BGPoMegaShare789*',
                                        companyId: '2',
                                    }).catch(err => {
                                        setLoading(false)
                                        message.success(t('common.tips21'))
                                    })
                                    const token = res?.data?.data?.access_token
                                    const MMOData = await postMMOFlagDataData(
                                        {
                                            date: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                            locationCallSign: callSign,
                                            timezone: getTfcTimezone(localTimeDifference),
                                        },
                                        token
                                    ).catch(err => {
                                        setLoading(false)
                                        message.success(t('common.tips21'))
                                    })

                                    const cardData = Object.values(MMOData?.data?.data).flat() || []

                                    await cardData?.forEach((item, index) => {
                                        item.id = index
                                        item.startTime = item.startTime.split(' ')[1]
                                        item.endTime = item.endTime.split(' ')[1]
                                        item.latitude = dmsToDecimal(item.latitude)
                                        item.longitude = dmsToDecimal(item.longitude)
                                        item.occurance = item.count
                                        item.comment = item.description
                                    })

                                    setLoading(false)
                                    setImportFlagData({
                                        MMOData: cardData,
                                    })
                                    message.success(t('common.tips20'))
                                }}
                            >
                                {t('HseDiary.importFromFlag')}
                            </Button>
                        </>
                    ) : (
                        <></>
                    )}
                    {type === 'Consumable' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) ? (
                        <Button
                            type='button'
                            className='ant-btn ant-btn-default btn importFromFlag'
                            loading={loading}
                            onClick={() => {
                                setLoading(true)
                                pushConsumableImportData({
                                    locationIds: [locationId],
                                    projectId: userInfo?.user?.projectId,
                                    startDate: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                    endDate: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                })
                                    .then(res => {
                                        setLoading(false)
                                        setImportFlagData(res?.data?.data)
                                        message.success(t('common.tips20'))
                                    })
                                    .catch(err => {
                                        setLoading(false)
                                        message.success(t('common.tips21'))
                                    })
                            }}
                        >
                            {t('HseDiary.importFromFlag')}
                        </Button>
                    ) : (
                        <></>
                    )}
                    {!hasPerms(permissionCode, 'monitor', locationId, readOnly) ? (
                        <Button
                            className={classnames('btn', {
                                'btn-update': needUpdate,
                            })}
                            onClick={() => {
                                if (needUpdate) debounce(handleAllSave(), 2000)
                            }}
                            loading={btnLoading}
                        >
                            {needUpdate ? t('common.btnNeed') : t('common.btn')}
                        </Button>
                    ) : (
                        <></>
                    )}
                </div>
            </Card>

            {/* 多行文本录入区域 */}
            {type === 'ActivityDiary' ? (
                <>
                    <Card className='comment summary operationalSummary'>
                        <div className='title'>
                            <span>{t('ActivityDiary.operationalSummary')}</span>
                            <span
                                className='copyPervious'
                                style={{ marginRight: '26px' }}
                                onClick={() => {
                                    const dayBefore = dayjs(calendarInfo).subtract(1, 'day').format('YYYY-MM-DD')
                                    importBeforeDayData({ dayBefore, type: 'operationalSummary' })
                                }}
                            >
                                {t('Weather.copyPervious')}
                            </span>
                        </div>
                        <div className='body'>
                            <Input.TextArea value={operationalSummary} onChange={handleOperationalSummaryChange} />
                        </div>
                    </Card>
                    <Card className='comment summary'>
                        <div className='title'>
                            <span>{t('ActivityDiary.next24Hours')}</span>
                            <span
                                className='copyPervious'
                                style={{ marginRight: '26px' }}
                                onClick={() => {
                                    const dayBefore = dayjs(calendarInfo).subtract(1, 'day').format('YYYY-MM-DD')
                                    importBeforeDayData({ dayBefore, type: 'next24Hours' })
                                }}
                            >
                                {t('Weather.copyPervious')}
                            </span>
                        </div>
                        <div className='body'>
                            <Input.TextArea value={next24Hours} onChange={handleNext24HoursChange} />
                        </div>
                    </Card>
                </>
            ) : (
                <></>
            )}

            {/* 可编辑表格区域 */}
            <div className='content'>
                {editColumnsList.map((columns, index) => (
                    <Card className={'editableTable' + (index + 1)} key={index}>
                        {/* 表格标题、以及一些统计数据 */}
                        <div className='title'>
                            <div className='left'>
                                <div>{t(`${type}.${'tableTitle' + (index + 1)}`)}</div>
                                {type === 'Acquisition' && (
                                    <>
                                        <div className='shots'>
                                            <span className='label'>{t('Acquisition.goodShots')}</span>:{' '}
                                            <span className={`value`}>{String(shotsObj.goodShots)}</span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Acquisition.badShots')}</span>:{' '}
                                            <span className={`value`}>{String(shotsObj.badShots)}</span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Acquisition.badChargeableShots')}</span>:{' '}
                                            <span className={`value`}>{String(shotsObj.badChargeableShots)}</span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Acquisition.PreplotShots')}</span>:{' '}
                                            <span className={`value`}>{String(shotsObj.preplotSkippedShots)}</span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Acquisition.otherShots')}</span>:{' '}
                                            <span className={`value`}>{String(shotsObj.otherShots)}</span>
                                        </div>
                                    </>
                                )}
                                {type === 'Consumable' && (
                                    <>
                                        {dictData &&
                                            dictData[0]?.data.data.map((item, index) => (
                                                <div className='shots' key={index}>
                                                    <span className='label'>
                                                        {language === 'zh'
                                                            ? item.dictLabel + '可用：'
                                                            : item.dictLabelEn + ' Available：'}
                                                    </span>
                                                    <span className='value'>{shotsConsumableObj[item.dictValue]}</span>
                                                    <span className='label' style={{ marginLeft: '20px' }}>
                                                        {language === 'zh'
                                                            ? item.dictLabel + '累计使用：'
                                                            : item.dictLabelEn + ' Cumulative Usage：'}
                                                    </span>
                                                    <span className='value'>{shotsConsumptionObj[item.dictValue]}</span>
                                                </div>
                                            ))}
                                    </>
                                )}
                                {type === 'Receive' && (
                                    <>
                                        <div className='shots'>
                                            <span className='label'>{t('Receive.totalReceives')}</span>:{' '}
                                            <span className={`value`}>
                                                <span>{String(shotsReceiveObj.deploymentShots)}</span>
                                                <span className='value-text'>/</span>
                                                <span>{String(shotsReceiveObj.retrievalShots)}</span>
                                            </span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Receive.PreplotStations')}</span>:{' '}
                                            <span className={`value`}>
                                                <span>{String(shotsReceiveObj.preplotSkippedShots)}</span>
                                                <span className='value-text'>/</span>
                                                <span>{String(shotsReceiveObj.retrievalPreplotSkippedShots)}</span>
                                            </span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Receive.skippedStations')}</span>:{' '}
                                            <span className={`value`}>
                                                <span>{String(shotsReceiveObj.deploymentSkipShots)}</span>
                                                <span className='value-text'>/</span>
                                                <span>{String(shotsReceiveObj.retrievalSkipShots)}</span>
                                            </span>
                                        </div>
                                    </>
                                )}
                                {type === 'ReceiveLand' && (
                                    <>
                                        <div className='shots'>
                                            <span className='label'>{t('Receive.totalReceives')}</span>:{' '}
                                            <span className={`value`}>
                                                <span>{String(shotsReceiveObj.deploymentShots)}</span>
                                                <span className='value-text'>/</span>
                                                <span>{String(shotsReceiveObj.retrievalShots)}</span>
                                            </span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Receive.PreplotStations')}</span>:{' '}
                                            <span className={`value`}>
                                                <span>{String(shotsReceiveObj.preplotSkippedShots)}</span>
                                                <span className='value-text'>/</span>
                                                <span>{String(shotsReceiveObj.retrievalPreplotSkippedShots)}</span>
                                            </span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Receive.skippedStations')}</span>:{' '}
                                            <span className={`value`}>
                                                <span>{String(shotsReceiveObj.deploymentSkipShots)}</span>
                                                <span className='value-text'>/</span>
                                                <span>{String(shotsReceiveObj.retrievalSkipShots)}</span>
                                            </span>
                                        </div>
                                    </>
                                )}
                                {type === 'Vibrator' && index === 0 && (
                                    <>
                                        <div className='shots'>
                                            <span className='label'>{t('Vibrator.sourceShots')}</span>:{' '}
                                            <span className={`value`}>{String(shotsObj.sourceShots)}</span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Vibrator.wellShots')}</span>:{' '}
                                            <span className={`value`}>{String(shotsObj.wellShots)}</span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Vibrator.airGunShots')}</span>:{' '}
                                            <span className={`value`}>{String(shotsObj.airGunShots)}</span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Vibrator.others')}</span>:{' '}
                                            <span className={`value`}>{String(shotsObj.others)}</span>
                                        </div>
                                        <div className='shots'>
                                            <span className='label'>{t('Vibrator.skippedShots')}</span>:{' '}
                                            <span className={`value`}>{String(shotsObj.skippedShots)}</span>
                                        </div>
                                    </>
                                )}
                                {type === 'Vibrator' && index === 1 && (
                                    <div className='vibrator'>
                                        <div className='top'>
                                            <div className='vibratorContent'>
                                                <div className='vibSummary'>
                                                    <span className='label'>{t('Vibrator.vibs')}</span>：{' '}
                                                    <span className={`value`}>
                                                        <span>{headerData?.vibs}</span>
                                                    </span>
                                                </div>
                                                <div className='vibSummary'>
                                                    <span className='label'>{t('Vibrator.app')}</span>：{' '}
                                                    <span className={`value`}>
                                                        <span>{headerData?.app}</span>
                                                    </span>
                                                </div>
                                                <div className='vibSummary'>
                                                    {/* <span className='label'>{t('Vibrator.skipped')}</span>:{' '} */}
                                                    <span className={`label`}>
                                                        <span>
                                                            <EditableInput
                                                                value={editValue}
                                                                setValue={setEditValue}
                                                                title={t('Vibrator.skipped')}
                                                                handleEditValue={handleEditValue}
                                                            />
                                                        </span>
                                                    </span>
                                                </div>
                                                <div className='vibSummary'>
                                                    <span className='label'>{t('Vibrator.tcf')}</span>：{' '}
                                                    <span className={`value`}>
                                                        <span>{headerData?.tcf?.toFixed(2)}</span>
                                                    </span>
                                                </div>
                                                <div className='vibSummary'>
                                                    <span className='label'>{t('Vibrator.ctm')}</span>：{' '}
                                                    <span className={`value`}>
                                                        <span>{headerData?.ctm}</span>
                                                    </span>
                                                </div>
                                                <div className='vibSummary'>
                                                    <span className='label'>{t('Vibrator.a')}</span>：{' '}
                                                    <span className={`value`}>
                                                        <span>{headerData?.purchasePercent?.toFixed(2)}</span>
                                                    </span>
                                                </div>
                                                <div className='vibSummary'>
                                                    <span className='label'>{t('Vibrator.avgAps')}</span>：{' '}
                                                    <span className={`value`}>
                                                        <span>{headerData?.avgVps}</span>
                                                    </span>
                                                </div>
                                                <div className='vibSummary'>
                                                    <span className='label'>{t('Vibrator.maxVpsHr')}</span>：{' '}
                                                    <span className={`value`}>
                                                        <span>{headerData?.maxVps}</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='editableTable'>
                                {type === 'ActivityDiary' && (
                                    <div className='right'>
                                        {!hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                            <span
                                                className='copyPervious'
                                                style={{ marginRight: '26px' }}
                                                onClick={() => {
                                                    const dayBefore = dayjs(calendarInfo)
                                                        .subtract(1, 'day')
                                                        .format('YYYY-MM-DD')
                                                    importBeforeDayData({ dayBefore, type: 'list' })
                                                }}
                                            >
                                                {t('Weather.copyPervious')}
                                            </span>
                                        )}
                                        {!hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                            <Button
                                                type='button'
                                                className='ant-btn ant-btn-default btn importFromFlag'
                                                loading={loading}
                                                onClick={() => {
                                                    setLoading(true)
                                                    if (receiverTypeList?.includes('obn')) {
                                                        pushActivityDiaryImportData({
                                                            locationId: locationId,
                                                            projectId: userInfo?.user?.projectId,
                                                            produceDate: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                                        })
                                                            .then(res => {
                                                                setLoading(false)
                                                                let result = res?.data?.data
                                                                if (!result || result?.length === 0) {
                                                                    return message.warning(t('ActivityDiary.tips1'))
                                                                }
                                                                const compareDate1 = (t1, t2) => {
                                                                    if (!t1 || !t2) return -1
                                                                    var date = new Date()
                                                                    var a = t1.split(':')
                                                                    var b = t2.split(':')
                                                                    return (
                                                                        date.setHours(a[0], a[1]).valueOf() -
                                                                        date.setHours(b[0], b[1]).valueOf()
                                                                    )
                                                                }

                                                                const compareDate2 = (t1, t2) => {
                                                                    if (!t1 || !t2) return false
                                                                    var date = new Date()
                                                                    var a = t1.split(':')
                                                                    var b = t2.split(':')
                                                                    return (
                                                                        date.setHours(a[0], a[1]) >
                                                                        date.setHours(b[0], b[1])
                                                                    )
                                                                }

                                                                if (dataSourceList[0]?.length === 0) {
                                                                    setImportFlagData(result)
                                                                    message.success(t('common.tips20'))
                                                                } else {
                                                                    const lastOldDate = dataSourceList[0]?.sort(
                                                                        (a, b) => compareDate1(b.endTime, a.endTime)
                                                                    )[0]

                                                                    const newDateArray = result?.filter(item =>
                                                                        compareDate2(
                                                                            item.endTime ?? '23:59',
                                                                            lastOldDate?.endTime
                                                                        )
                                                                    )
                                                                    const formatOldArray = dataSourceList[0].map(item =>
                                                                        formatTableData(item)
                                                                    )
                                                                    setImportFlagData(
                                                                        [...formatOldArray, ...newDateArray].sort(
                                                                            (a, b) =>
                                                                                compareDate1(
                                                                                    a.endTime ?? '23:59',
                                                                                    b.endTime ?? '23:59'
                                                                                )
                                                                        )
                                                                    )
                                                                    message.success(t('common.tips20'))
                                                                }
                                                            })
                                                            .catch(_ => {
                                                                setLoading(false)
                                                                message.warning(t('common.tips21'))
                                                            })
                                                    } else {
                                                        pushActivityDiaryStreamerImportData({
                                                            locationId: locationId,
                                                            projectId: userInfo?.user?.projectId,
                                                            produceDate: dayjs(calendarInfo).format('YYYY-MM-DD'),
                                                        })
                                                            .then(res => {
                                                                setLoading(false)
                                                                let result = res?.data?.data
                                                                if (!result || result?.length === 0) {
                                                                    return message.warning(t('ActivityDiary.tips1'))
                                                                }
                                                                const compareDate1 = (t1, t2) => {
                                                                    if (!t1 || !t2) return -1
                                                                    var date = new Date()
                                                                    var a = t1.split(':')
                                                                    var b = t2.split(':')
                                                                    return (
                                                                        date.setHours(a[0], a[1]).valueOf() -
                                                                        date.setHours(b[0], b[1]).valueOf()
                                                                    )
                                                                }

                                                                const compareDate2 = (t1, t2) => {
                                                                    if (!t1 || !t2) return false
                                                                    var date = new Date()
                                                                    var a = t1.split(':')
                                                                    var b = t2.split(':')
                                                                    return (
                                                                        date.setHours(a[0], a[1]) >
                                                                        date.setHours(b[0], b[1])
                                                                    )
                                                                }

                                                                if (dataSourceList[0]?.length === 0) {
                                                                    setImportFlagData(result)
                                                                    message.success(t('common.tips20'))
                                                                } else {
                                                                    const lastOldDate = dataSourceList[0]?.sort(
                                                                        (a, b) => compareDate1(b.endTime, a.endTime)
                                                                    )[0]

                                                                    const newDateArray = result?.filter(item =>
                                                                        compareDate2(
                                                                            item.endTime ?? '23:59',
                                                                            lastOldDate?.endTime
                                                                        )
                                                                    )
                                                                    const formatOldArray = dataSourceList[0].map(item =>
                                                                        formatTableData(item)
                                                                    )
                                                                    setImportFlagData(
                                                                        [...formatOldArray, ...newDateArray].sort(
                                                                            (a, b) =>
                                                                                compareDate1(
                                                                                    a.endTime ?? '23:59',
                                                                                    b.endTime ?? '23:59'
                                                                                )
                                                                        )
                                                                    )
                                                                    message.success(t('common.tips20'))
                                                                }
                                                            })
                                                            .catch(_ => {
                                                                setLoading(false)
                                                                message.warning(t('common.tips21'))
                                                            })
                                                    }
                                                }}
                                            >
                                                {t('ActivityDiary.importFromSource')}
                                            </Button>
                                        )}
                                        {!hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                            <div className='importAndExport'>
                                                <Upload
                                                    beforeUpload={file => {
                                                        handleImportActivityDiaryCSV(file)
                                                        return false
                                                    }}
                                                    maxCount={1}
                                                    itemRender={() => <></>}
                                                    accept='.csv'
                                                >
                                                    <span className='import'>{t('Acquisition.import')}</span>
                                                </Upload>
                                                <span
                                                    className='exportActivityDiary'
                                                    onClick={handleExportActivityDiaryCSV}
                                                >
                                                    {t('Acquisition.export')}
                                                </span>
                                            </div>
                                        )}

                                        <div className='duration'>
                                            <span className='duration-title'>
                                                {t('ActivityDiary.durationAll') + ': '}
                                            </span>
                                            <span
                                                className='duration-time'
                                                style={{
                                                    color:
                                                        Number(getAllDuration(dataSourceList[index])) === 24
                                                            ? 'green'
                                                            : 'red',
                                                }}
                                            >
                                                {getAllDuration(dataSourceList[index])}
                                            </span>
                                        </div>
                                    </div>
                                )}
                                {type === 'Vibrator' && (
                                    <div className='right'>
                                        {index === 0 && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                            <div className='importAndExport'>
                                                <span className='exportActivityDiary' onClick={handleExportVIBCSV}>
                                                    {t('Acquisition.export')}
                                                </span>
                                            </div>
                                        )}
                                        {index === 1 && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                            <div className='importAndExport'>
                                                <span className='exportActivityDiary' onClick={uploadFile}>
                                                    {t('Acquisition.export')}
                                                </span>
                                                <span className='exportActivityDiary' onClick={clearFileData}>
                                                    {t('Vibrator.clear')}
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {type === 'FleetSummary' && index === 0 && (
                                    <div className='right'>
                                        {!hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                            <div className='importAndExport'>
                                                <Upload
                                                    beforeUpload={file => {
                                                        handleImportActivityDiaryCSV(file)
                                                        return false
                                                    }}
                                                    maxCount={1}
                                                    itemRender={() => <></>}
                                                    accept='.csv'
                                                >
                                                    <span className='import'>{t('Acquisition.import')}</span>
                                                </Upload>
                                                <span
                                                    className='exportActivityDiary'
                                                    onClick={handleExportProjectActivityCSV}
                                                >
                                                    {t('Acquisition.export')}
                                                </span>
                                                {/* <Dropdown
                                            overlay={
                                                <Menu
                                                    items={[
                                                        {
                                                            key: '3',
                                                            label: (
                                                                <Upload
                                                                    beforeUpload={file => {
                                                                        handleImportExcel(file)
                                                                        return false
                                                                    }}
                                                                    maxCount={1}
                                                                    itemRender={() => <></>}
                                                                >
                                                                    <span className='importExcel'>
                                                                        {t('Acquisition.importExcel')}
                                                                    </span>
                                                                </Upload>
                                                            ),
                                                        },
                                                        {
                                                            key: '4',
                                                            label: (
                                                                <Upload
                                                                    beforeUpload={file => {
                                                                        handleImportCSV(file)
                                                                        return false
                                                                    }}
                                                                    maxCount={1}
                                                                    itemRender={() => <></>}
                                                                >
                                                                    <span className='importCSV'>
                                                                        {t('Acquisition.importCSV')}
                                                                    </span>
                                                                </Upload>
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            }
                                        >
                                            <span className='import'>{t('Acquisition.import')}</span>
                                        </Dropdown> */}
                                                {/* <Dropdown
                                            overlay={
                                                <Menu
                                                    items={[
                                                        {
                                                            key: '1',
                                                            label: (
                                                                <div onClick={handleExportExcel}>
                                                                    {t('Acquisition.exportExcel')}
                                                                </div>
                                                            ),
                                                        },
                                                        {
                                                            key: '2',
                                                            label: (
                                                                <div onClick={handleExportCSV}>
                                                                    {t('Acquisition.exportCSV')}
                                                                </div>
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            }
                                        >
                                            <span className='export'>{t('Acquisition.export')}</span>
                                        </Dropdown> */}
                                            </div>
                                        )}

                                        <div className='duration'>
                                            <span className='duration-title'>
                                                {t('ActivityDiary.durationAll') + ': '}
                                            </span>
                                            <span
                                                className='duration-time'
                                                style={{
                                                    color:
                                                        Number(getAllDuration(dataSourceList[index])) === 24
                                                            ? 'green'
                                                            : 'red',
                                                }}
                                            >
                                                {getAllDuration(dataSourceList[index])}
                                            </span>
                                        </div>
                                    </div>
                                )}
                                {type === 'Acquisition' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                    <div className='importAndExport'>
                                        <Upload
                                            beforeUpload={file => {
                                                handleImportCSV(file)
                                                return false
                                            }}
                                            maxCount={1}
                                            itemRender={() => <></>}
                                            accept='.csv'
                                        >
                                            <span className='import'>{t('Acquisition.import')}</span>
                                        </Upload>
                                        <span className='export' onClick={handleExportCSV}>
                                            {t('Acquisition.export')}
                                        </span>
                                        {/* <Dropdown
                                            overlay={
                                                <Menu
                                                    items={[
                                                        {
                                                            key: '3',
                                                            label: (
                                                                <Upload
                                                                    beforeUpload={file => {
                                                                        handleImportExcel(file)
                                                                        return false
                                                                    }}
                                                                    maxCount={1}
                                                                    itemRender={() => <></>}
                                                                >
                                                                    <span className='importExcel'>
                                                                        {t('Acquisition.importExcel')}
                                                                    </span>
                                                                </Upload>
                                                            ),
                                                        },
                                                        {
                                                            key: '4',
                                                            label: (
                                                                <Upload
                                                                    beforeUpload={file => {
                                                                        handleImportCSV(file)
                                                                        return false
                                                                    }}
                                                                    maxCount={1}
                                                                    itemRender={() => <></>}
                                                                >
                                                                    <span className='importCSV'>
                                                                        {t('Acquisition.importCSV')}
                                                                    </span>
                                                                </Upload>
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            }
                                        >
                                            <span className='import'>{t('Acquisition.import')}</span>
                                        </Dropdown> */}
                                        {/* <Dropdown
                                            overlay={
                                                <Menu
                                                    items={[
                                                        {
                                                            key: '1',
                                                            label: (
                                                                <div onClick={handleExportExcel}>
                                                                    {t('Acquisition.exportExcel')}
                                                                </div>
                                                            ),
                                                        },
                                                        {
                                                            key: '2',
                                                            label: (
                                                                <div onClick={handleExportCSV}>
                                                                    {t('Acquisition.exportCSV')}
                                                                </div>
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            }
                                        >
                                            <span className='export'>{t('Acquisition.export')}</span>
                                        </Dropdown> */}
                                    </div>
                                )}
                                {type === 'Receive' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                    <div className='importAndExport'>
                                        <Upload
                                            beforeUpload={file => {
                                                handleImportReceiveCSV(file)
                                                return false
                                            }}
                                            maxCount={1}
                                            itemRender={() => <></>}
                                            accept='.csv'
                                        >
                                            <span className='import'>{t('Acquisition.import')}</span>
                                        </Upload>
                                        <span className='export' onClick={handleExportReceiveCSV}>
                                            {t('Acquisition.export')}
                                        </span>
                                        {/* <Dropdown
                                            overlay={
                                                <Menu
                                                    items={[
                                                        {
                                                            key: '3',
                                                            label: (
                                                                <Upload
                                                                    beforeUpload={file => {
                                                                        handleImportExcel(file)
                                                                        return false
                                                                    }}
                                                                    maxCount={1}
                                                                    itemRender={() => <></>}
                                                                >
                                                                    <span className='importExcel'>
                                                                        {t('Acquisition.importExcel')}
                                                                    </span>
                                                                </Upload>
                                                            ),
                                                        },
                                                        {
                                                            key: '4',
                                                            label: (
                                                                <Upload
                                                                    beforeUpload={file => {
                                                                        handleImportCSV(file)
                                                                        return false
                                                                    }}
                                                                    maxCount={1}
                                                                    itemRender={() => <></>}
                                                                >
                                                                    <span className='importCSV'>
                                                                        {t('Acquisition.importCSV')}
                                                                    </span>
                                                                </Upload>
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            }
                                        >
                                            <span className='import'>{t('Acquisition.import')}</span>
                                        </Dropdown> */}
                                        {/* <Dropdown
                                            overlay={
                                                <Menu
                                                    items={[
                                                        {
                                                            key: '1',
                                                            label: (
                                                                <div onClick={handleExportExcel}>
                                                                    {t('Acquisition.exportExcel')}
                                                                </div>
                                                            ),
                                                        },
                                                        {
                                                            key: '2',
                                                            label: (
                                                                <div onClick={handleExportCSV}>
                                                                    {t('Acquisition.exportCSV')}
                                                                </div>
                                                            ),
                                                        },
                                                    ]}
                                                />
                                            }
                                        >
                                            <span className='export'>{t('Acquisition.export')}</span>
                                        </Dropdown> */}
                                    </div>
                                )}
                                {type === 'Weather' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                    <Popconfirm
                                        title={t('Weather.tips2')}
                                        onConfirm={() => {
                                            const dayBefore = dayjs(calendarInfo)
                                                .subtract(1, 'day')
                                                .format('YYYY-MM-DD')
                                            setCurrentDate(dayBefore)
                                            setIsmodifyTable(true)
                                            setIsToolTips(false)
                                        }}
                                        onCancel={() => {
                                            setIsToolTips(false)
                                        }}
                                        okText={t('common.OK')}
                                        cancelText={t('common.cancel')}
                                        visible={isToolTips}
                                    >
                                        <div
                                            className='copyPervious'
                                            onClick={() => {
                                                if (dataSourceList[0].length !== 0 || commentValue !== '') {
                                                    setIsToolTips(true)
                                                    return
                                                }
                                                const dayBefore = dayjs(calendarInfo)
                                                    .subtract(1, 'day')
                                                    .format('YYYY-MM-DD')
                                                setCurrentDate(dayBefore)
                                                setIsmodifyTable(true)
                                            }}
                                        >
                                            {t('Weather.copyPervious')}
                                        </div>
                                    </Popconfirm>
                                )}
                                {type === 'Consumable' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                    <Popconfirm
                                        title={t('Weather.tips2')}
                                        onConfirm={() => {
                                            const dayBefore = dayjs(calendarInfo)
                                                .subtract(1, 'day')
                                                .format('YYYY-MM-DD')
                                            setCurrentDate(dayBefore)
                                            setIsmodifyTable(true)
                                            setIsToolTips(false)
                                        }}
                                        onCancel={() => {
                                            setIsToolTips(false)
                                        }}
                                        okText={t('common.OK')}
                                        cancelText={t('common.cancel')}
                                        visible={isToolTips}
                                    >
                                        <div
                                            className='copyPervious'
                                            onClick={() => {
                                                if (dataSourceList[0].length !== 0 || commentValue !== '') {
                                                    setIsToolTips(true)
                                                    return
                                                }
                                                const dayBefore = dayjs(calendarInfo)
                                                    .subtract(1, 'day')
                                                    .format('YYYY-MM-DD')
                                                setCurrentDate(dayBefore)
                                                setIsmodifyTable(true)
                                            }}
                                        >
                                            {t('Weather.copyPervious')}
                                        </div>
                                    </Popconfirm>
                                )}
                                {type === 'HseDiary' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                    <>
                                        {index === 2 ? (
                                            <span
                                                className='copyPervious'
                                                onClick={() => {
                                                    const dayBefore = dayjs(calendarInfo)
                                                        .subtract(1, 'day')
                                                        .format('YYYY-MM-DD')
                                                    importBeforeDayData(dayBefore)
                                                }}
                                            >
                                                {t('Weather.copyPervious')}
                                            </span>
                                        ) : (
                                            <></>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>

                        {/* 可编辑表格 */}
                        <div className='body'>
                            <EditableProTable
                                columns={columns} // 列数据
                                value={dataSourceList[index]} // 行数据
                                rowKey='id' // 行数据 key
                                actionRef={actionRefList[index]} // table 操作实例
                                editableFormRef={formRefList[index]} // table 所有的 form，带了一些表格特有的操作
                                columnEmptyText={false} // 空值时的显示，不设置时显示 -， false 可以关闭此功能
                                loading={isUpdate}
                                onValuesChange={(rowKey, record) => {
                                    if (!saveData || !record) return
                                    let editData = [...saveData]
                                    const saveIndex = saveData.findIndex(item => item?.id === record?.id)
                                    if (saveIndex !== -1) {
                                        editData[saveIndex] = { ...record, saveType: 'save' }
                                    } else {
                                        if (!record?.id) return
                                        editData.push({ ...record, saveType: 'save' })
                                    }
                                    setSaveData(editData)
                                }}
                                onRow={record => ({
                                    onClick: !hasPerms(permissionCode, 'monitor', locationId, readOnly)
                                        ? event => {
                                              const className = event?.target?.getAttribute('class') ?? ''
                                              const hasEllipsisOutlined =
                                                  className.indexOf('EllipsisOutlined') === -1 ? false : true // 排除三个点触发
                                              if (event?.target?.tagName === 'svg') return
                                              if (hasEllipsisOutlined) return
                                              setRowKeys[index]([record.id])
                                          }
                                        : () => {}, // 鼠标移入行
                                })}
                                recordCreatorProps={
                                    (index === 0 || type !== 'Vibrator') &&
                                    !hasPerms(permissionCode, 'monitor', locationId, readOnly)
                                        ? {
                                              newRecordType: 'dataSource', // 允许同时新增多行配置
                                              disabled: isUpdate,
                                              record: () => {
                                                  // Acquisition、Receive 的 swath 默认值
                                                  const lastRecord = [...(dataSourceList[index] ?? [])].pop() ?? {}
                                                  // Hse Diary 第一条的 hours 默认值
                                                  //   const firstRecord = [...(dataSourceList[2] ?? [])]
                                                  const firstSwath = dictData
                                                      ? [...(dictData?.[2]?.data?.data ?? [])].shift()?.id
                                                      : ''
                                                  const firstSourceParameter = sourceData
                                                      ? [...sourceData]?.shift()?.id
                                                      : ''
                                                  const firstZipperParameter = zipperData
                                                      ? [...zipperData]?.shift()?.id
                                                      : ''
                                                  const defaultValue = () => {
                                                      switch (type) {
                                                          case 'Acquisition':
                                                              return {
                                                                  swath: lastRecord.swath ?? firstSwath,
                                                                  type: '564-1022',
                                                                  areaType: lastRecord.areaType ?? 'premier',
                                                                  status: '582-1030',
                                                                  averageCycleTime: lastRecord.averageCycleTime,
                                                                  badShots: '0',
                                                                  badChargeableShots: '0',
                                                                  preplotSkippedShots: '0',
                                                                  otherShots: '0',
                                                                  sourceParameter:
                                                                      lastRecord.sourceParameter ??
                                                                      firstSourceParameter,
                                                                  zipperId: lastRecord.zipperId ?? firstZipperParameter,
                                                                  solTime: lastRecord.eolTime,
                                                              }
                                                          case 'Receive':
                                                              return {
                                                                  swath: lastRecord.swath ?? firstSwath,
                                                                  type: lastRecord.type ?? 'premier',
                                                                  status: '603-1224',
                                                                  method: lastRecord.method ?? 'rov',
                                                                  preplotSkippedStations: '0',
                                                                  skippedStations: '0',
                                                                  solTime: lastRecord.eolTime,
                                                              }
                                                          case 'ReceiveLand':
                                                              return {
                                                                  swath: lastRecord.swath ?? firstSwath,
                                                                  typeOfRls:
                                                                      dataSourceList[index].length === 0
                                                                          ? beforeOneDayData?.[
                                                                                beforeOneDayData?.length - 1
                                                                            ]?.typeOfRls
                                                                          : lastRecord?.typeOfRls,
                                                                  status: '603-1224',
                                                                  typeOfReceiver:
                                                                      dataSourceList[index].length === 0
                                                                          ? beforeOneDayData?.[
                                                                                beforeOneDayData?.length - 1
                                                                            ]?.typeOfReceiver
                                                                          : lastRecord?.typeOfReceiver,
                                                                  method: lastRecord.method ?? 'rov',
                                                                  preplotSkippedStations: '0',
                                                                  skippedStations: '0',
                                                                  solTime: lastRecord.eolTime,
                                                                  activity: lastRecord.activity,
                                                              }
                                                          case 'ActivityDiary':
                                                              return {
                                                                  startTime: lastRecord.endTime,
                                                              }
                                                          case 'FleetSummary':
                                                              return {
                                                                  startTime: lastRecord.endTime,
                                                              }
                                                          case 'Consumable':
                                                              return {
                                                                  unit: lastRecord.unit,
                                                              }
                                                          case 'HseDiary':
                                                              return {
                                                                  exposureHour: lastRecord.exposureHour ?? '16-163',
                                                                  company: '36-2',
                                                              }
                                                          default:
                                                              return {}
                                                      }
                                                  }

                                                  return {
                                                      id: Date.now(), // 新增行 id
                                                      ...defaultValue(), // 某些默认值
                                                  }
                                              },
                                              creatorButtonText: t('common.addNew'), // 自定义新增按钮文字内容
                                              onClick: () => {
                                                  setTimeout(() => {
                                                      /* 竖向滚动到底部 */
                                                      const dom =
                                                          document.getElementsByClassName('ant-table-body')[index]
                                                      if (!dom) return
                                                      dom.scrollTop = dom?.scrollHeight
                                                  }, 0)
                                              },
                                          }
                                        : false
                                }
                                editable={{
                                    type: 'multiple', // 允许多行编辑模式，'single' 只能单行编辑模式
                                    editableKeys: rowKeys[index], // 编辑模式下的 rowkey 数组
                                    actionRender: (row, config, defaultDoms) => {
                                        return [
                                            <span
                                                key='insert'
                                                className='insertBtn'
                                                onClick={() => {
                                                    actionRefList[index].current.addEditRecord(
                                                        { id: Date.now(), count: String(row.index), isInsert: true }, // 往最后一行新增, 记下需要插入的索引
                                                        { newRecordType: 'dataSource' } // 新增行默认可编辑模式
                                                    )
                                                }}
                                            >
                                                {t('common.insertRow')}
                                            </span>,
                                            defaultDoms.delete,
                                        ]
                                    }, // 操作按钮配置
                                    onChange: (editableKeys, editableRows) => {
                                        setRowKeys[index]([editableKeys.pop()]) // 只编辑最新一行
                                    },
                                    onValuesChange: (value, allValue) => {
                                        // 向上一行插入，处理
                                        setIsmodifyTable(true)
                                        const result = [...allValue]
                                        if (result.length > 0) {
                                            const popRow = result.pop()
                                            if (popRow.isInsert) {
                                                delete popRow.isInsert
                                                result.splice(Number(popRow.count), 0, popRow)
                                            } else {
                                                result.push(popRow)
                                            }
                                        }
                                        // 新增一个计数，引起数据更新
                                        const result2 = result.map((item, index) => ({ ...item, countNum: index }))
                                        return setDataSourceList[index](result2) // 设置值
                                    }, // 收集新增 event 数据
                                    deletePopconfirmMessage: () => {
                                        // 删除时弹出的确认框提示消息, 默认值：删除此行？
                                        return <div>{t('common.deletePopconfirmMessage')}</div>
                                    },
                                }}
                                scroll={{ x: 800, y: 517 }} // 固定列，注意，非固定列宽度之和不要超过 scroll.x，留一列不设宽度自适应
                                bordered={true} // 展示边框
                            />
                        </div>
                    </Card>
                ))}

                {/* 项目总结，文本区域 */}
                {type === 'FleetSummary' ? (
                    <>
                        {/* Overview概述 */}
                        <Card className='comment summary operationSummary'>
                            <div className='title'>{t('FleetSummary.operation')}</div>
                            <div className='body operationArea'>
                                {/* //// */}
                                <Input.TextArea value={operationSummary} onChange={handleOperationSummaryChange} />
                            </div>
                        </Card>
                        {/* 来源容器 */}
                        <Card className='comment summary SourceVesselsSummary'>
                            <div className='title'>{t('FleetSummary.SourceVessels')}</div>
                            <div className='body'>
                                <Input.TextArea value={sourceVessels} onChange={handlesourceVesselsChange} />
                            </div>
                        </Card>
                        {/* nodeVessels */}
                        <Card className='comment summary NodeVesselsSummary'>
                            <div className='title'>{t('FleetSummary.nodeVessels')}</div>
                            <div className='body'>
                                <Input.TextArea value={nodeVessels} onChange={handlenodeVesselsChange} />
                            </div>
                        </Card>
                        {/* hseSummary */}
                        <Card className='comment summary hseSummary'>
                            <div className='title'>{t('FleetSummary.hse')}</div>
                            <div className='body'>
                                <Input.TextArea value={hseSummary} onChange={handleHseSummaryChange} />
                            </div>
                        </Card>
                        {/* SIMPOS */}
                        <Card className='comment summary SIMOPSSummary'>
                            <div className='title'>{t('FleetSummary.SIMOPS')}</div>
                            <div className='body'>
                                <Input.TextArea value={simops} onChange={handlesimopsChange} />
                            </div>
                        </Card>
                        {/* 航运 */}
                        <Card className='comment summary shippingSummary'>
                            <div className='title'>{t('FleetSummary.shipping')}</div>
                            <div className='body'>
                                <Input.TextArea value={shipping} onChange={handleShippingChange} />
                            </div>
                        </Card>
                        {/* 海上交通 */}
                        <Card className='comment summary marineTrafficSummary'>
                            <div className='title'>{t('FleetSummary.marineTraffic')}</div>
                            <div className='body'>
                                <Input.TextArea value={marineTraffic} onChange={handleMarineTrafficChange} />
                            </div>
                        </Card>
                        {/* MUA */}
                        <Card className='comment summary MUASuspensionsSummary'>
                            <div className='title'>{t('FleetSummary.MUASuspensions')}</div>
                            <div className='body'>
                                <Input.TextArea
                                    value={muaSuspensionsSummary}
                                    onChange={handlemuaSuspensionsSummaryChange}
                                />
                            </div>
                        </Card>
                        {/* 天气 */}
                        <Card className='comment summary weatherSummary'>
                            <div className='title'>{t('FleetSummary.Weather')}</div>
                            <div className='body'>
                                <Input.TextArea value={weatherSummary} onChange={handleweatherSummaryChange} />
                            </div>
                        </Card>
                        {/* 浅水 */}
                        <Card className='comment summary ShallowWaterSummary'>
                            <div className='title'>{t('FleetSummary.ShallowWater')}</div>
                            <div className='body'>
                                <Input.TextArea value={shallowWater} onChange={handleShallowWaterChange} />
                            </div>
                        </Card>
                        {/* 再补给&后勤 */}
                        <Card className='comment summary ResupplyLogisticsSummary'>
                            <div className='title'>{t('FleetSummary.ResupplyLogistics')}</div>
                            <div className='body'>
                                <Input.TextArea value={resupplyLogistics} onChange={handleresupplyLogisticsChange} />
                            </div>
                        </Card>
                        {/* 护卫/支持船舰 */}
                        <Card className='comment summary GuardSupportVesselsSummary'>
                            <div className='title'>{t('FleetSummary.GuardSupportVessels')}</div>
                            <div className='body'>
                                <Input.TextArea value={supportVessels} onChange={handlesupportVesselsChange} />
                            </div>
                        </Card>
                        {/* 障碍物 */}
                        <Card className='comment summary ObstructionsSummary'>
                            <div className='title'>{t('FleetSummary.Obstructions')}</div>
                            <div className='body'>
                                <Input.TextArea value={Obstructions} onChange={handleObstructionsChange} />
                            </div>
                        </Card>
                        <Card className='comment summary othersSummary'>
                            <div className='title'>{t('FleetSummary.others')}</div>
                            <div className='body'>
                                <Input.TextArea value={others} onChange={handleOthersChange} />
                            </div>
                        </Card>
                        <Card className='comment summary hoursSummary'>
                            <div className='title'>{t('FleetSummary.hours')}</div>
                            <div className='body'>
                                <Input.TextArea value={hours} onChange={handleHoursSummaryChange} />
                            </div>
                        </Card>
                    </>
                ) : (
                    <></>
                )}

                {/* 除了项目总结，其他所有备注区域 */}
                {type === 'FleetSummary' ? (
                    <></>
                ) : (
                    <Card className='comment'>
                        <div className='title'>
                            {t(`${type}.comment`)}{' '}
                            {type === 'HseDiary' && !hasPerms(permissionCode, 'monitor', locationId, readOnly) && (
                                <span
                                    className='copyPervious'
                                    onClick={() => {
                                        const dayBefore = dayjs(calendarInfo).subtract(1, 'day').format('YYYY-MM-DD')
                                        importBeforeDayData(dayBefore, 'comment')
                                    }}
                                >
                                    {t('Weather.copyPervious')}
                                </span>
                            )}
                        </div>
                        <div className='body'>
                            <Input.TextArea disabled={isUpdate} value={commentValue} onChange={handleCommentChange} />
                        </div>
                    </Card>
                )}
            </div>
        </div>
    )
}
